import KmDialog from './main.vue'
KmDialog.install = function (vue) {
  vue.component(KmDialog.name, KmDialog)
}
export default KmDialog



// WEBPACK FOOTER //
// ./src/ui/components/km-dialog/index.js